import { useEffect } from "preact/hooks";

interface ApplicationShortcutHandlers {
  readonly onChooseFiles: () => void;
  readonly onShowQuickSearch: () => void;
  readonly onCloseActiveTab: () => boolean;
  readonly onDismissTransientUi: () => void;
}

export function useApplicationShortcuts({
  onChooseFiles,
  onShowQuickSearch,
  onCloseActiveTab,
  onDismissTransientUi,
}: ApplicationShortcutHandlers): void {
  useEffect(() => {
    const handleKeyboard = (event: KeyboardEvent): void => {
      const commandKey = event.metaKey || event.ctrlKey;
      const key = event.key.toLowerCase();

      if (commandKey && event.shiftKey && key === "f") {
        event.preventDefault();
        onShowQuickSearch();
      } else if (commandKey && key === "o") {
        event.preventDefault();
        onChooseFiles();
      } else if (commandKey && key === "w") {
        if (onCloseActiveTab()) {
          event.preventDefault();
        }
      } else if (event.key === "Escape") {
        onDismissTransientUi();
      }
    };

    window.addEventListener("keydown", handleKeyboard);
    return () => window.removeEventListener("keydown", handleKeyboard);
  }, [
    onChooseFiles,
    onShowQuickSearch,
    onCloseActiveTab,
    onDismissTransientUi,
  ]);
}
